/* eslint-disable @typescript-eslint/no-magic-numbers */
import Vue from 'vue';
import dom from './FreeModalDom.vue';
import AssistantModal from './AssistantModal';
import { eventBus } from '../../mixins/StayStrategyMixin';

const FreeConstructor = Vue.extend(dom);
const pool: Array<any> = [];

const getAnInstance = () => {
  if (pool.length > 0) {
    const instance = pool[0];
    pool.splice(0, 1);
    return instance;
  }
  return new FreeConstructor({
    el: document.createElement('div'),
  });
};

const returnAnInstance = (instance: any) => {
  if (instance) {
    pool.push(instance);
  }
};

const removeDom = (event: any) => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target);
  }
};

const FreeModal = () => {
  const instance = getAnInstance();
  document.body.appendChild(instance.$el);

  instance.init = function(data: any) {
    instance.strategyData = data;
  };
  instance.show = function(val: string) {
    instance.visible = true;
  };
  instance.hide = function() {
    instance.visible = false;
    instance.$el.addEventListener('transitionend', removeDom);
    returnAnInstance(this);
  };
  instance.cancel = function() {
    instance.hide();
    eventBus.$emit('track', 'landingpage_free_popup_button_click', {
      button_name: '彻底放弃本次学习机会',
      trigger_method: instance.strategyData.triggerMethod,
    });
  };
  instance.confirm = function() {
    eventBus.$emit('track', 'landingpage_free_popup_button_click', {
      button_name: '立即免费报名',
      trigger_method: instance.strategyData.triggerMethod,
    });

    instance.hide();
    handleShowAssistant(instance.strategyData);
  };
  return instance;
};

const handleShowAssistant = (data: any) => {
  AssistantModal.init(data);
  AssistantModal.show();

  eventBus.$emit('track', 'landingpage_assistant_popup', {
    popup_name: '二维码弹窗',
    trigger_method: data.triggerMethod,
  });
};

export default FreeModal();
